import { combineReducers } from 'redux';

import * as actionTypes from '../action-creator/actionTypes';
import * as systemActionTypes from '../../system/action-creator/actionTypes';

const email = (state = "", action) => {
  switch(action.type){
    case actionTypes.SET_EMAIL:
      return action.email;
    default:
      return state;
  }
}

const emailError = (state = "", action) => {
  switch(action.type){
    case actionTypes.SET_EMAIL:
      return action.emailError;
    default:
      return state;
  }
}

const password = (state = "", action) => {
  switch(action.type){
    case actionTypes.SET_PASSWORD:
      return action.password;
    case systemActionTypes.LOGIN_SUCCESS:
      return "";
    default:
      return state;
  }
}

const passwordError = (state = "", action) => {
  switch(action.type){
    case actionTypes.SET_PASSWORD:
      return action.passwordError;
    default:
      return state;
  }
}

const logInFailedMessage = (state = "", action) => {
  switch(action.type){
    case systemActionTypes.SHOW_INCORRECT_CREDENTIAL_MSG:
    case systemActionTypes.LOGIN_FAILURE:
      return action.message;
    case systemActionTypes.LOGIN_REQUEST:
      return "";
    default:
      return state;
  }
}

export default combineReducers({
  email,
  password,
  emailError,
  passwordError,
  logInFailedMessage
});

const getLoginState = state => state.login;

export const getEmail = state => getLoginState(state).email

export const getEmailError = state => getLoginState(state).emailError

export const getPassword = state => getLoginState(state).password;

export const getPasswordError = state => getLoginState(state).passwordError;

export const getIsValid = state => {
  const loginState = getLoginState(state);
  return loginState.email && loginState.password;
}

export const getLogInFailedMessage = state => getLoginState(state).logInFailedMessage